<template>
  <div class="default-title">
    <div class="list-top-margin">
      <div class="list-top-margin" style="display: flex;align-items: center;">
        <i class="el-icon-warning" style="color: #e6a23c;font-size: 22px;"></i>
        <span class="left-default-margin" style="font-weight: bold;">您确定要清空 “ 云管家小工单演示环境 ” 的数据吗？</span>
      </div>
      <div style="padding-left: 35px;">
        <div class="list-top-margin">系统已存在数据！确定后将清空所有数据，且无法还原。如确定删除，请输入下面超管账号密码:</div>
        <div>
          <span>管理员账号密码&nbsp;&nbsp;</span>
          <el-input v-model="input" placeholder="请输入超管账号密码" size="small" style="width: calc(100% - 200px);"></el-input>
        </div>
      </div>
    </div>
    <div slot="footer" class="text-align-center" style="position: relative;">
      <el-button size="small" @click="cancel">取 消</el-button>
      <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input:''
    }
  },
  methods:{
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.$emit('done',{type:'save'})
    },
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/systemSetting/factorySys/create-dialog.vue